import { render, staticRenderFns } from "./MediaNicheIcon.vue?vue&type=template&id=39303199&scoped=true"
import script from "./MediaNicheIcon.vue?vue&type=script&lang=js"
export * from "./MediaNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39303199",
  null
  
)

export default component.exports